/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { SystemMessageState, SystemMessageSlots } from './SystemMessage.types';

/**
 * Render the final JSX of SystemMessage
 */
export const renderSystemMessage_unstable = (state: SystemMessageState): JSXElement => {
  assertSlots<SystemMessageSlots>(state);

  return (
    <state.root>
      {state.icon && <state.icon />}
      {state.message && (
        <state.message>
          {state.accessibleHeading && <state.accessibleHeading />}
          {state.root.children}
        </state.message>
      )}
    </state.root>
  );
};
